import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaStringNode extends ValuableNode {
  @fromSpecific()
  @reactive()
  format?: string

  @fromSpecific()
  @reactive()
  maxLength?: number

  @fromSpecific()
  @reactive()
  minLength?: number

  @fromSpecific()
  @reactive()
  pattern?: string
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.String': SchemaStringNode
  }
}
